import styles from './notifications.module.scss';
import {Main} from '../../components/main/main.tsx';
import {__} from '../../support/lang/translations.ts';

export function NotificationEmpty() {
    return (
        <Main>
            <div className={styles.notification_empty}>
                <h2>{__('notifications.titles.empty')}</h2>
                <p>{__('notifications.copy.empty')}</p>
            </div>
        </Main>
    );
}
